export const quotationMarkSizes = {
  Default: 1,
  'Extra Small': 0.5,
  Small: 0.7,
  Medium: 1.3,
  Large: 1.5,
};

export type QuotationMarkSizesType = keyof typeof quotationMarkSizes;
